module.exports = __webpack_public_path__ + "img/line-chart-up-05.0b617a86.svg";